/** @jsxImportSource @emotion/react */
import React from "react";

import * as styles from "./styles";

export const LoadingBarComponent = ({
  className = "",
  ...props
}: React.ComponentProps<"div">) => {
  return (
    <div
      className={`loading_element loading_bar ${styles.styleBar} ${className}`}
      {...props}
    ></div>
  );
};

export const LoadingCircleComponent = ({
  className = "",
  ...props
}: React.ComponentProps<"div">) => {
  return (
    <div
      className={`
      loading_element loading_cirlce ${styles.styleCircle} ${className}`}
      {...props}
    ></div>
  );
};
